export const TAB_BAR_ITEM_HORIZONTAL_PADDING = 12;
